import React from 'react';
import { connect } from 'react-redux';
import { updateReviewInfo } from './thunks';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import setting from './setting';
import 'bootstrap/dist/css/bootstrap.min.css';
import './FileDownloadModal.css';

const FileDownloadModal = ({ userInfo, reviewInfo, startUpdateReviewInfo }) => {
  
  
  const handleClose = () => { 
    startUpdateReviewInfo({ showFileDownloadDialog:false });
  };
  
  const onChangeType = (e) => {
    let type = e.target.value;
    console.log('change type to:', type);
    startUpdateReviewInfo({ downloadType: type });
  }
  
  const onChangeFormat = (e) => {
    let format = e.target.value;
    console.log('change format to:', format);
    startUpdateReviewInfo({ downloadFormat:format });
  }
  
  const handleDownload = () => {
    console.log('download review output files');
    var fileType = document.querySelector('input[name="file_type"]:checked').value;
    var fileFormat = document.querySelector('input[name="file_format"]:checked').value;
    var program = reviewInfo.program;
    var study = reviewInfo.study;
    var milestone = reviewInfo.milestone;
    var groupId = reviewInfo.groupId;
    var reviewFilesDownloadUrl = 
      `${setting.annotation_server}/review/files/download` + 
      `?program=${program}&study=${study}&milestone=${milestone}&` + 
      `groupId=${groupId}&type=${fileType}&format=${fileFormat}`;
    window.open(reviewFilesDownloadUrl, '_blank');
    handleClose();
  };
  
  const content = (
    <Modal size="lg" show={reviewInfo.showFileDownloadDialog} onHide={handleClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Choose Output Files to Download</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={3}>Review Status</Col>
            <Col md={2}>
              <Form.Check custom type="radio" label="All" value="all" name="file_type" id="file_type_all" 
                checked = { reviewInfo.downloadType == 'all' } onChange={onChangeType} />
            </Col>
            <Col md={4}>
              <Form.Check custom type="radio" label="Official Released" value="released" name="file_type" id="file_type_released" 
                checked = { reviewInfo.downloadType == 'released' } onChange={onChangeType} />
            </Col>
          </Row>
          <Row>
            <Col md={3}>File Format</Col>
            <Col md={2}>
              <Form.Check custom type="radio" label="PDF" value="pdf" name="file_format" id="file_format_pdf" 
                checked = { reviewInfo.downloadFormat == 'pdf' } onChange={onChangeFormat} />
            </Col>
            <Col md={4}>
              <Form.Check custom type="radio" label="RTF" value="rtf" name="file_format" id="file_format_rtf" 
                checked = { reviewInfo.downloadFormat == 'rtf' } onChange={onChangeFormat} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <br/>
              <Button className="btn-bps" variant="light" onClick={handleDownload} >Download</Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
  return content;
};

const mapState = state => ({
  reviewInfo: state.reviewInfo,
  userInfo: state.userInfo
});

const mapDispatch = dispatch => ({
  startUpdateReviewInfo: (data) => dispatch(updateReviewInfo(data)),
});

export default connect(mapState, mapDispatch)(FileDownloadModal);
